import { incomeCategoryDeleteApi } from "../../api/incomeCategory/incomeCategoryDeleteApi"

type PayloadShape = Parameters<typeof incomeCategoryDeleteApi>[0]

export async function incomeCategoryDeleteService(payload: PayloadShape, token: string) {
	return await incomeCategoryDeleteApi(payload, token)
}
